import consumer from "./consumer"

consumer.subscriptions.create("ConversationChannel", {
  // Called once when the subscription is created.
  // initialized() {
  //   console.log('initialized ConversationChannel Room!');
  // },

  // Called when the subscription is ready for use on the server.
  connected() {
    console.log('Connected to ConversationChannel!');
  },

  // Called when the WebSocket connection is closed.
  disconnected() {
    // console.log('disconnected from ConversationChannel!');
  },

  received(data) {
    //console.log("Received:", data)

    // Called when there's incoming data on the websocket for this channel
    // if user is inside the contact center
    if (data.event != undefined && data.event == "sent") {
      var current_u_id = parseInt($("#imLink").data("current-u"));
      var sender_id = parseInt(data.sender_id);
      var recipient_ids = data.recipient_ids;

      // check if user is in the conversation
      if (recipient_ids.includes(current_u_id)) {
        if (current_u_id != sender_id) {
          var ims_count = parseInt($("#imLink").data("ims-count"));
          if (ims_count > 0) {
            $("#imLink").find(".badge").html(ims_count + 1);
            $("#imLink").data("ims-count", ims_count + 1);
            $("#imLink").attr("data-ims-count", ims_count + 1);
          } else {
            $("#imLink").append("<span class='badge elevatero_badge bg_red float-right mt--3 ml--3'>1</span>");
            $("#imLink").data("ims-count", 1);
            $("#imLink").attr("data-ims-count", 1);
          }
        }
        $(".internal_list_of_comments_"+data.convo_id).append(data.html);

        if ($("#windowChat-"+data.convo_id).length > 0) {
          var user_id = $("#windowChat-"+data.convo_id).data("current-u");
          if (parseInt(user_id) != sender_id) {
            $("#chatComment-"+data.message_id).removeClass("text-right");
            $("#chatComment-"+data.message_id).find(".comment-body").removeClass("outbound").addClass("inbound");
            var permissions = data.recipient_permissions[current_u_id];
            if (permissions) {
              if (permissions.sound) {
                playNotification("conversation");
              }

              if (permissions.desktop) {
                createNotification(data.sender_name, data.message_preview);
              }
            }
          }
          if ($("#windowChat-"+data.convo_id).find(".messages-body").isInViewport()) {
            scrollToUnread(data.convo_id, 0);
            markChatAsRead($("#windowChat-"+data.convo_id));
          } else {
            $("#windowChat-"+data.convo_id).addClass("pending");
          }
        } else if (current_u_id != sender_id) {
          // open window with pending class minimized
          $.ajax({
            url: '/conversations/open',
            data: {
              convo_id: data.convo_id,
              minimized: true
            }
          });

          var permissions = data.recipient_permissions[current_u_id];
          if (permissions) {
            if (permissions.sound) {
              playNotification("conversation");
            }

            if (permissions.desktop) {
              createNotification(data.sender_name, data.message_preview);
            }
          }

        }
      }

    } // if (data.event == "sent")

    if ($("#escalated_messages_view").length == 0) {

      // Open/Close conversation
      if (data.toggle_status != undefined) {
        var source = $('body').data('source');

        if (source == data.source) {
          if ( $("#chat-contacts").length > 0 && $("#chat-contacts").data('filter') != 'new_chat' ) {
            if ( ($("#chat-contacts").data('filter') == 'own_inbox_open' && data.open_contact_center == false) ||
                ($("#chat-contacts").data('filter') == 'own_inbox_close' && data.open_contact_center == true) ) {
              if (data.contact_id != '')
                $(".cc-contact-card[data-contact-id='" + data.contact_id + "']").remove();
              else
                $(".cc-contact-card[data-phone-number='" + data.phone_number + "']").remove();
            } else
              $("#chat-contacts.sms").prepend(data.contact_html);
            $('[data-toggle="tooltip"]').tooltip();
          }

          if ( $("#chat-messages").length > 0 ) {
            var chatMessages = null;
            if (data.contact_id != '')
              chatMessages = $("#chat-messages[data-contact-id='" + data.contact_id + "']");
            else
              chatMessages = $("#chat-messages[data-phone-number='" + data.phone_number + "']");
            chatMessages.html(data.message_intro);
            //console.log(chatMessages.length)

            //Show an alert
            var userId = $('#chat-messages').data('msgu').replace('mu', ''),
                action = data.open_contact_center == true ? 'opened' : 'closed';
            if (userId != data.user_id && chatMessages.length > 0)
              alert(data.user_name + ' ' + action + ' this conversation')

            chatMessages.removeAttr('data-contact-id');
            chatMessages.removeAttr('data-phone-number');
          }
        }
      }

      // Refresh sidebar
      if ($("#chat-contacts").length > 0 && data.event != undefined && data.event == "refresh_sidebar") {
        var source = $('body').data('source'),
            userId = $('body').data('msgu').replace('mu', '');
        if (source == data.source && userId == data.user_id) {
          setTimeout(function() {
            $.getScript("/contact_center/filter_contacts?message_type=sms&filter=own_inbox_open&refresh_sidebar=true");
          }, 500);
        }
      }
    }

    if (data.event != undefined && data.event == "toastr") {
      var userId = $('body').data('msgu').replace('mu', '');
      if (userId == data.user_id) {
        // Display an info toast with title
        // toastr.info(data.message, data.title, {timeOut: 0, closeButton: true});
        var t = toastr.info(data.message, data.title, {timeOut: 0, closeButton: true,
              onCloseClick: function(a, b) {
                $.getScript("/close_notifications?tid=t-" + data.tid);
              },
              onclick: function(a, b) {
                $.getScript("/close_notifications?tid=t-" + data.tid);
              }
            });
        t.attr('id', 't-' + data.tid);

        if (data.contacts_count)
          $("#account-program[data-id='" + data.account_id + "'] tr[data-program-id='" + data.program_id + "'] td.contacts span.contacts-added").text(data.added_contacts_count + " / " + data.contacts_count);
      }
    }

    if (data.event != undefined && data.event == "close_toastr") {
      $('#' + data.tid).closest('.toast').remove();
    }

    if (data.event != undefined && data.event == "ai_suggestion") {
      var conversationId = data.conversation_id;
      var contactId = data.contact_id;
      var suggestionId = data.suggestion_id;
      var suggestion = data.suggestion;

      if ($('.messages-body').attr('data-conversation') == conversationId && $('#chat-messages').attr('data-contact-id') == contactId) {
        var txtSmsContent = $('#sms_message_content');

        $('#sms_message_ai_suggestion_id').val(suggestionId);
        txtSmsContent.val(suggestion);

        var btnAiRes = $('.js-ai-response');
        btnAiRes.removeClass('btn-white');
        btnAiRes.addClass('btn-light');
        btnAiRes.find('.main-icon').removeClass('d-none');
        btnAiRes.find('.sec-icon').addClass('d-none');

        //Increase textarea height if there is text that is not visible
        if (isThereHiddenText(txtSmsContent)) {
          var objHeight = txtSmsContent.height();
          var newHeight = objHeight * 2;
          txtSmsContent.height(newHeight);

          if (isThereHiddenText(txtSmsContent)) {
            newHeight = newHeight * 1.35;
            txtSmsContent.height(newHeight);
          }
        }
      }
    }
  }
})


// $(function() {
//   $('[data-channel-subscribe="conversation"]').each(function(index, element) {
//     var $element = $(element),
//         room_id = $element.data('convo-id');
//         // messageTemplate = $('[data-role="message-template"]');
//
//     // $element.animate({ scrollTop: $element.prop("scrollHeight")}, 1000)
//
//     consumer.subscriptions.create(
//       {
//         channel: "ConversationChannel",
//         room: convo_id
//       },
//       {
//         received: function(data) {
//           console.log(data);
//         }
//       }
//     );
//   });
// });
